import { useRole } from "modules/roles/hooks/useRole";

export function useIsConfigurator() {
  const role = useRole();
  return role?.includes("CONFIGURATOR");
}
